'use strict';

import keyMirror from 'keymirror';

module.exports = keyMirror({
    HIDE_SPINNER: null,
    TOGGLE_ELIGIBILITY_CHECK_COMPLETE: null
});



// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./constants/DeclarationConstants.js